import axios from "axios";
import { BASE_URL, SUB_URL } from "./BaseUrl";

const ReportService = {

    getItem: async () => {
        try {
            const response = await axios.get(`${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL.get_item_no}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching Line:", error);
            return [];
        }
    },

    getPObyItem: async (value) => {
        console.log("getPObyItem-selected item", value);

        try {
            const formData = new FormData();
            formData.append('item_no', value);

            const response = await axios.post(`${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL.get_po_by_item}`, formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
            return response.data;
        } catch (error) {
            console.error("Error in getting POs");

        }
    },

    getColorByPO: async (poValue) => {
        try {
            const formData = new FormData();
            formData.append('po_no', poValue);

            const response = await axios.post(`${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL.get_color}`, formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
            return response.data;
            // return { "status": true, "message": "PO Details Found", "data": [{ "set_id": "1", "po_no": "10000A", "color": "BLUE", "tot_qty": "1000", "priority": "1", "ship_date": null, "ship_perce": "100", "item_no": "000A", "country": "MEX", "sizes": "{\"S\":\"200\",\"M\":\"400\",\"L\":\"200\",\"XL\":\"200\"}", "style_no": "TEST", "ship_size_perc": "{\"S\":\"100\",\"M\":\"100\",\"L\":\"100\",\"XL\":\"100\"}", "ship_size_qty": "{\"S\":\"200\",\"M\":\"400\",\"L\":\"200\",\"XL\":\"200\"}", "pack_min_pcs": "{\"S\":\"\",\"M\":\"\",\"L\":\"\",\"XL\":\"\"}", "pack_min_weight": "{\"S\":\"\",\"M\":\"\",\"L\":\"\",\"XL\":\"\"}", "tolerance": "{\"S\":\"\",\"M\":\"\",\"L\":\"\",\"XL\":\"\"}", "prepack": null, "customer": "ABC", "package_type": "Solid" }] };
        } catch (error) {
            console.error("Error in getting POs");

        }
    },
    getEolReport: async (startDate, endDate, selectedPoNo, selectedItem, value) => {

        const formData = new FormData();
        
        const formValues = {
            from_date: startDate,
            to_date: endDate,
            po_no: selectedPoNo,
            item_no: selectedItem,
            color: value
        };
    
        // Append only non-empty, non-null, defined values to formData
        Object.entries(formValues)
            .filter(([key, val]) => val !== null && val !== undefined && val !== '')
            .forEach(([key, val]) => formData.append(key, val));
    

        try {
            const response = await axios.post(`${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL.get_eol_report}`, formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            console.log(response.data);
            return response.data;

        } catch (error) {

        }
    },

    displayActiveKanban: async (lineData) => {
        console.log(lineData);
        

        const formData = new FormData();
        formData.append('line_no', lineData);

        try {
            const response = await axios.post(`${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL.display_active_kanban}`, formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            return response.data;
        } catch (error) {

        }
    },
    get_inward_outward_report: async (startDate, endDate, type, location) => {
        
        const formData = new FormData();
        formData.append('from_date', startDate);
        formData.append('to_date', endDate);
        formData.append('type', type);
        formData.append('location', location);

        try {
            const response = await axios.post(
                // `https://unit42.smartekanban.in/index.php/Apiv4/inward_outward_report`
                `${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL.get_inward_outward_report}`
                , formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            return response.data;
        } catch (error) {

        }
    },

};

export default ReportService;
